/**
 * MIRVMissile - Multiple Independent Reentry Vehicle missile
 * Splits into 2-3 child warheads mid-flight.
 * Introduced at wave 4+.
 */

import { Missile } from './Missile.js';

export class MIRVMissile extends Missile {
  constructor(opts) {
    super({
      ...opts,
      color: opts.color || '#cc44ff',
      trailColor: opts.trailColor || '#9922cc',
    });

    this.type = 'mirv';
    this.hasSplit = false;
    this.splitRatio = 0.4 + Math.random() * 0.2; // Split at 40-60% of journey
    this.childCount = 2 + (Math.random() > 0.5 ? 1 : 0); // 2 or 3 children
    this.childMissiles = []; // Populated when split occurs
    this.gameWidth = opts.gameWidth || 1280;
    this.gameHeight = opts.gameHeight || 720;
  }

  update(dt) {
    if (!this.alive) return;

    // Check if we should split
    if (!this.hasSplit && this.traveled >= this.totalDist * this.splitRatio) {
      this._split();
      return;
    }

    super.update(dt);
  }

  _split() {
    this.hasSplit = true;
    this.alive = false;

    // Create child warheads with offset targets
    for (let i = 0; i < this.childCount; i++) {
      const offsetX = (Math.random() - 0.5) * 150; // +/- 75px offset
      const childTargetX = Math.max(20, Math.min(this.gameWidth - 20, this.targetX + offsetX));

      this.childMissiles.push({
        x: this.x,
        y: this.y,
        targetX: childTargetX,
        targetY: this.targetY,
        speed: this.speed * 1.1, // Children slightly faster
        color: '#dd66ff',
        trailColor: '#aa44dd',
      });
    }
  }

  render(ctx) {
    if (!this.alive && this.trail.length === 0) return;

    // Draw trail (thicker than basic)
    if (this.trail.length > 1) {
      for (let i = 1; i < this.trail.length; i++) {
        const alpha = i / this.trail.length;
        ctx.strokeStyle = this.trailColor;
        ctx.globalAlpha = alpha * 0.7;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(this.trail[i - 1].x, this.trail[i - 1].y);
        ctx.lineTo(this.trail[i].x, this.trail[i].y);
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }

    // Draw missile head (slightly larger with glow)
    if (this.alive) {
      ctx.save();
      ctx.shadowColor = this.color;
      ctx.shadowBlur = 6;
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(this.x, this.y, 3, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }
  }
}
